"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryMenuLoader = void 0;
var react_1 = __importDefault(require("react"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var client_1 = require("@apollo/client");
var CategoryMenu_1 = __importDefault(require("./CategoryMenu"));
var ui_1 = require("@aperza/ui");
var util_1 = require("@aperza/util");
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query CategoryMenuLoaderQuery($langCode: String, $sellerFlag: Boolean) {\n    productCategories(langCode: $langCode, sellerFlag: $sellerFlag) {\n      displayCategoryId\n      level\n      name\n      itemCount\n      children {\n        displayCategoryId\n        level\n        name\n        itemCount\n      }\n    }\n  }\n"], ["\n  query CategoryMenuLoaderQuery($langCode: String, $sellerFlag: Boolean) {\n    productCategories(langCode: $langCode, sellerFlag: $sellerFlag) {\n      displayCategoryId\n      level\n      name\n      itemCount\n      children {\n        displayCategoryId\n        level\n        name\n        itemCount\n      }\n    }\n  }\n"])));
var CategoryMenuLoader = function (props) {
    var appConfig = util_1.AppService.appConfig();
    var locale = appConfig.langCode;
    var disableMarketplaceBanner = props.disableMarketplaceBanner;
    var sellerFlag = false;
    if (util_1.AppConfigService.shouldShowMarketplaceTopBanner() || !disableMarketplaceBanner) {
        sellerFlag = true;
    }
    var _a = client_1.useQuery(QUERY, {
        variables: {
            langCode: locale,
            sellerFlag: sellerFlag,
        },
    }), loading = _a.loading, error = _a.error, data = _a.data, refetch = _a.refetch, fetchMore = _a.fetchMore;
    if (loading) {
        return (react_1.default.createElement("div", { id: "categoryMenu" },
            react_1.default.createElement(ui_1.Loading, null)));
    }
    if (error) {
        return react_1.default.createElement("div", null, error.message);
    }
    return react_1.default.createElement(CategoryMenu_1.default, __assign({ productCategories: data.productCategories }, props));
};
exports.CategoryMenuLoader = CategoryMenuLoader;
exports.default = CategoryMenuLoader;
var templateObject_1;
